import request from '@/utils/request'

export const getInvoices = params => request.get('/accounting/invoices', { params })

export const createInvoice = data => request.post('/accounting/invoices', data)

export const getInvoice = id => request.get(`/accounting/invoices/${id}`)

export const updateInvoice = (id, data) => request.put(`/accounting/invoices/${id}`, data)

export const deleteInvoice = id => request.delete(`/accounting/invoices/${id}`)

export const issueInvoice = id => request.post(`/accounting/invoices/${id}/issue`)

export const recordInvoicePayment = (id, data) => request.post(`/accounting/invoices/${id}/payments`, data)

export const applyInvoiceAdvance = (id, data) => request.post(`/accounting/invoices/${id}/apply-advance`, data)

export const cancelInvoice = id => request.post(`/accounting/invoices/${id}/cancel`)

export const getCustomerStatement = (id, params) => request.get(`/accounting/customers/${id}/statement`, { params })

export const getCustomerAdvanceBalance = id => request.get(`/accounting/customers/${id}/advance-balance`)
